import {
  ImportDocumentRequest,
  QuoteDocumentConfig,
} from '@monetize/types/app';
import { ChangeEvent, FC, RefObject } from 'react';
import { MButton, MFlex, MText } from '../../../../../components/Monetize';
import { QuoteDocumentsMode } from './constants';
import { SelectQuoteDocumentsPopover } from './SelectQuoteDocumentsPopover';

interface QuoteDocumentsToolbarSharedProps {
  fileInputRef: RefObject<HTMLInputElement>;
  replaceInputRef: RefObject<HTMLInputElement>;
  acceptAttr: string;
  onUploadClick: () => void;
  onFileInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onReplaceInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

type QuoteDocumentsToolbarProps =
  | (QuoteDocumentsToolbarSharedProps & {
      mode: QuoteDocumentsMode.QUOTE;
      availableDocuments: QuoteDocumentConfig[];
      isAvailableDocumentsLoading: boolean;
      isImportingDocuments: boolean;
      onImportDocuments: (items: ImportDocumentRequest[]) => Promise<void>;
    })
  | (QuoteDocumentsToolbarSharedProps & { mode: QuoteDocumentsMode.SETTINGS });

export const QuoteDocumentsToolbar: FC<QuoteDocumentsToolbarProps> = (
  props,
) => {
  const {
    fileInputRef,
    replaceInputRef,
    acceptAttr,
    onUploadClick,
    onFileInputChange,
    onReplaceInputChange,
  } = props;

  return (
    <MFlex alignItems="center" gap={3} mb={3} flexWrap="wrap">
      {props.mode === QuoteDocumentsMode.QUOTE && (
        <>
          <SelectQuoteDocumentsPopover
            availableDocuments={props.availableDocuments}
            isLoading={props.isAvailableDocumentsLoading}
            isImporting={props.isImportingDocuments}
            onAdd={props.onImportDocuments}
          />
          <MText fontSize="xs" color="tGray.darkPurple">
            |
          </MText>
        </>
      )}
      <MText color="tGray.darkPurple">
        <MButton
          variant="link"
          data-testid="quote-upload-document-link"
          onClick={onUploadClick}
          fontWeight="bold"
        >
          Upload from computer
        </MButton>{' '}
        or drag and drop files before or after the quote below
      </MText>

      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept={acceptAttr}
        style={{ display: 'none' }}
        onChange={onFileInputChange}
      />
      <input
        ref={replaceInputRef}
        type="file"
        accept={acceptAttr}
        style={{ display: 'none' }}
        onChange={onReplaceInputChange}
      />
    </MFlex>
  );
};
